import { ModalHeader } from '@/components/modals';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { Alert, DialogContent, Link } from '@mui/material';
import { useState } from 'react';

export default function NewPassword({ password, email, mode, error }: { password: string; email: string; mode: string; error?: string }) {
  const [copiedField, setCopiedField] = useState<string | null>(null);
  const [visible, setVisible] = useState<string[]>([]);

  // Function to copy text to clipboard and show feedback
  const copyToClipboard = (value: string, field: string) => {
    navigator.clipboard.writeText(value);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 2000);
  };

  const switchVisible = (field: string) => {
    setVisible((prevVisible) =>
      prevVisible.includes(field)
        ? prevVisible.filter((f) => f !== field)
        : [...prevVisible, field]
    );
  };

  return (
    <>
      <ModalHeader title={`${mode} Epp Password Reset`} />
      <DialogContent>
        <div className="flex flex-col gap-16">

          <Alert severity={error ? 'error' : 'warning'}>
            {error ? (<>
              <p>There was an error resetting your {mode} Epp password.</p>
              <p>{error}</p>
            </>
            ) : (
              <>
                <p>Your {mode} Epp password has been successfully reset.</p>
                <p>The new password has been sent to your email [{email}].</p>
              </>
            )}
          </Alert>
          <div className="flex flex-col items-center w-full justify-center">
            {error ? <><Link className={'bg-primary text-white px-16 rounded py-8 hover:bg-[#298738]'} target="_blank" href="https://zacities.africa/contact-us/">Contact Support</Link></> : 

              <div className="w-full flex items-center justify-between bg-gray-300 dark:bg-gray-800 rounded-lg px-6 sm:px-10 py-6 mb-8 [@media(max-width:960px)]:mb-0 break-words ">
                <p className="text-sm sm:text-base font-medium text-black dark:text-white me-8">
                  Password:
                </p>
                <div className="flex items-center gap-8">
                  <span className="text-sm sm:text-base text-gray-700 dark:text-white">
                    {visible.includes('password') ? password : '●'.repeat(password.length)}
                  </span>
                  <div className="flex items-center gap-4">


                  <FuseSvgIcon
                    size={20}
                    className="text-gray-500 dark:text-gray-400 cursor-pointer"
                    onClick={() => switchVisible('password')}
                  >
                    {visible.includes('password')
                      ? 'heroicons-outline:eye-slash'
                      : 'heroicons-outline:eye'}
                  </FuseSvgIcon>
                  <FuseSvgIcon
                    size={20}
                    className="text-gray-500 dark:text-gray-400 cursor-pointer"
                    onClick={() => copyToClipboard(password, 'password')}
                  >
                    {copiedField === 'password'
                      ? 'heroicons-outline:check-circle'
                      : 'heroicons-outline:square-2-stack'}
                  </FuseSvgIcon></div>
                </div>
              </div>
            }
          </div>
        </div>

      </DialogContent>
    </>
  );
}
